import {Component} from "@angular/core";

@Component({
    selector: 'accordion-header',
    template: require('./accordion.header.template.html')
})
export class AccordionHeaderComponent {

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/accordion/accordion.header.component.ts